import { Produto } from "../../models";


export const ARADO_SUBSOLADOR: Produto = {
    Codigo: 1,
    Nome: 'Arado Subsolador',
    Modelo: 'GIR-1300',
    Capa: null, 
    Imagens: [
        {
            Capa: true,
            Ativo: true,
            Url: "assets/IPB/Produtos/Arado_Subsolador/arado_1.png",
        },
        {
            Url: "assets/IPB/Produtos/Arado_Subsolador/arado_2.png",
        },
        {
            Url: "assets/IPB/Produtos/Arado_Subsolador/arado_3.png",
        },
        {
            Url: "assets/IPB/Produtos/Arado_Subsolador/arado_4.png",
        },
        {
            Url: "assets/IPB/Produtos/Arado_Subsolador/arado_5.png",
        }
    ],
    Detalhes: [
        `5, 7 ou 9 garras`,
        `Garras ajustáveis`,
        `Garras fixas com Pino Fusível`,
        `Opção para 2 cabeçalhos`,
        `Opção roda reguladora de profundidade`,
        `Kit Destorroador`
    ],
    Modelos: [
        { Modelo: 'AS T1 5F', Detalhes: 'Largura corte 1,40m à 1,70m' },
        { Modelo: 'AS T2 7F', Detalhes: 'Largura corte 1,90m' },
        { Modelo: 'AS T2 9F', Detalhes: 'Largura corte 2,50m' }
    ]
}